import { Circle } from '@react-pdf/renderer';
import { MapType, SelectedLayersType } from '../../../types/dataTypes';
import LineLayer from './Infrastructure/LineLayer';
import MarkerLayer from './Infrastructure/MarkerLayer';
import CircleLayer from './Infrastructure/CircleLayer';

type InfrastructureLayersProps = {
    map: MapType;
    mapLoaded: boolean;
    selectedLayers: SelectedLayersType[];
}

function InfrastructureLayers({ map, mapLoaded, selectedLayers }: InfrastructureLayersProps) {
  return (
    <>
      {selectedLayers.filter((layer: SelectedLayersType) => layer.type === 'marker' && layer.geojsonName !== 'NA' && layer.isSelected).map((layer: SelectedLayersType) => (
        <MarkerLayer
          key={layer.layerId} 
          map={map}
          mapLoaded={mapLoaded}
          geojsonName={layer.geojsonName}
          layerId={layer.layerId}
          icon={layer.icon}
          detailDefinition={layer.detailDefinition}
          layerName={layer.layerName}
        />
      ))}
      {selectedLayers.filter((layer: SelectedLayersType) => layer.type === 'line' && layer.geojsonName !== 'NA' && layer.isSelected && layer.colour
      ).map((layer: SelectedLayersType) => (
        <LineLayer
          key={layer.layerId} 
          map={map}
          mapLoaded={mapLoaded}
          geojsonName={layer.geojsonName}
          layerId={layer.layerId}
          color={layer.colour}
          lineWeight={2}
          lineType={layer.lineType}
        />
      ))}
      {selectedLayers.filter((layer: SelectedLayersType) => layer.type === 'circle' && layer.geojsonName !== 'NA' && layer.isSelected && layer.colour
      ).map((layer: SelectedLayersType) => (
        <CircleLayer
          key={layer.layerId} 
          map={map}
          mapLoaded={mapLoaded}
          geojsonName={layer.geojsonName}
          layerId={layer.layerId}
          color={layer.colour}
          borderColor={layer.borderColor}
          lineWeight={4}
        />
      ))}
    </>
  )
}

export default InfrastructureLayers;